
import { IPackagingData } from "@/components/ActiveProjects/OtherLabeling/types/OtherLabeling.types";

const OtherLabelingInitial = (packagingData:any): IPackagingData => {
    return {
        id: packagingData?.id || '',
        sectionName: packagingData?.sectionName || '',
        otherInfo: packagingData?.otherInfo || {},
        recyclingIconsData: Array.isArray(packagingData?.recyclingIconsData)
            ? (packagingData?.recyclingIconsData?.length > 0
                ? packagingData.recyclingIconsData
                : [{
                    text: '',
                    supportingText: '',
                    useOnPack: ''
                }])
            : packagingData?.recyclingIconsData
                ? [{
                    text: (packagingData?.recyclingIconsData?.text ?? packagingData?.recyclingIconsData?.recyclingIconsText) || '',
                    supportingText: (packagingData?.recyclingIconsData?.supportingText ?? packagingData?.recyclingIconsData?.recyclingIconsSupportingText) || '',
                    useOnPack: packagingData?.recyclingIconsData?.useOnPack || ''
                }]
                : [{
                    text: '',
                    supportingText: '',
                    useOnPack: ''
                }],
        productLabellingDetailsData: {
            id: packagingData?.productLabellingDetailsData?.id,
            statementOfIdentity: packagingData?.productLabellingDetailsData?.statementOfIdentity || '',
            exactNameOnPackaging: packagingData?.productLabellingDetailsData?.exactNameOnPackaging || '',
            productStory: packagingData?.productLabellingDetailsData?.productStory || '',
            notesToDesign: packagingData?.productLabellingDetailsData?.notesToDesign || ''
        },
        otherLabellingInfoData: {
            productDescriptor: packagingData?.otherLabellingInfoData?.productDescriptor || '',
            otherProductMarketingInfo: packagingData?.otherLabellingInfoData?.otherProductMarketingInfo || '',
            foodSafetyOrHaccpPlanDesignation: packagingData?.otherLabellingInfoData?.foodSafetyOrHaccpPlanDesignation || '',
            brandType: packagingData?.otherLabellingInfoData?.brandType || 'No',
            otherBrandRegulatorySupplyDetails: packagingData?.otherLabellingInfoData?.otherBrandRegulatorySupplyDetails || '',
            exactNameOnPackaging: "",
            productStory: "",
            notesToDesign: ""
        },
        weightUnitsSpecificationData: {
            quantities: packagingData?.weightUnitsSpecificationData?.quantities || '',
            declaredQuantityType: packagingData?.weightUnitsSpecificationData?.declaredQuantityType || '',
            declaredQuantityPrintingBy: packagingData?.weightUnitsSpecificationData?.declaredQuantityPrintingBy || '',
            netDeclaredWeightVolume: packagingData?.weightUnitsSpecificationData?.netDeclaredWeightVolume || '',
            locationOnPack: packagingData?.weightUnitsSpecificationData?.locationOnPack || '',
            drainedWeight: packagingData?.weightUnitsSpecificationData?.drainedWeight || ''
        },
        iconsAndClaimsData: Array.isArray(packagingData?.iconsAndClaimsData)
            ? (packagingData?.iconsAndClaimsData?.length > 0
                ? packagingData.iconsAndClaimsData
                : [{
                    productClaims: '',
                    cautionStatements: '',
                    directionsForUse: ''
                }])
            : packagingData?.iconsAndClaimsData
                ? [packagingData.iconsAndClaimsData]
                : [{
                    productClaims: '',
                    cautionStatements: '',
                    directionsForUse: ''
                }],
        regionSpecificIconsData: Array.isArray(packagingData?.regionSpecificIconsData)
            ? (packagingData?.regionSpecificIconsData?.length > 0
                ? packagingData.regionSpecificIconsData
                : [{
                    site: '',
                    onPackIcons: '',
                    supportingTextForDeclaration: '',
                    useOnPack: ''
                }])
            : packagingData?.regionSpecificIconsData
                ? [packagingData.regionSpecificIconsData]
                : [{
                    site: '',
                    onPackIcons: '',
                    supportingTextForDeclaration: '',
                    useOnPack: ''
                }],
        nutritionDietaryIconsData: Array.isArray(packagingData?.nutritionDietaryIconsData)
            ? (packagingData?.nutritionDietaryIconsData?.length > 0
                ? packagingData.nutritionDietaryIconsData
                : [{
                    icon: '',
                    supportingTextForDeclaration: '',
                    useOnPack: ''
                }])
            : packagingData?.nutritionDietaryIconsData
                ? [{
                    icon: (packagingData?.nutritionDietaryIconsData?.icon ?? packagingData?.nutritionDietaryIconsData?.nutritionDietaryIcon) || '',
                    supportingTextForDeclaration: packagingData?.nutritionDietaryIconsData?.supportingTextForDeclaration || '',
                    useOnPack: packagingData?.nutritionDietaryIconsData?.useOnPack || ''
                }]
                : [{
                    icon: '',
                    supportingTextForDeclaration: '',
                    useOnPack: ''
                }],
        safetyProcessingEnvStatements: Array.isArray(packagingData?.safetyProcessingEnvStatements) && packagingData?.safetyProcessingEnvStatements?.length > 0 
            ? packagingData?.safetyProcessingEnvStatements 
            : (Array.isArray(packagingData?.safetyProcessingEnvironmentalData) && packagingData?.safetyProcessingEnvironmentalData?.length > 0 
                ? packagingData?.safetyProcessingEnvironmentalData 
                : [{
                    format: '',
                    text: '',
                    useOnPack: '',
                    statements: []
                }]),
        storageHandlingDistributionData: Array.isArray(packagingData?.storageHandlingDistributionData)
            ? (packagingData.storageHandlingDistributionData.length > 0
                ? packagingData.storageHandlingDistributionData.map((item: any) => ({
                    id: item?.id,
                    format: (item?.format ?? item?.storageHandlingFormat) || '',
                    text: (item?.text ?? item?.storageHandlingText) || '',
                    isKeepFrozenRequired: item?.isKeepFrozenRequired || false,
                    formats: item?.formats || [],
                }))
                : [{
                    format: '',
                    text: '',
                    isKeepFrozenRequired: false,
                    formats: [],
                }]
            )
            : packagingData?.storageHandlingDistributionData
                ? [{
                    id: packagingData?.storageHandlingDistributionData?.id,
                    format: (packagingData?.storageHandlingDistributionData?.format ?? packagingData?.storageHandlingDistributionData?.storageHandlingFormat) || '',
                    text: (packagingData?.storageHandlingDistributionData?.text ?? packagingData?.storageHandlingDistributionData?.storageHandlingText) || '',
                    isKeepFrozenRequired: packagingData?.storageHandlingDistributionData?.isKeepFrozenRequired || false,
                    formats: packagingData?.storageHandlingDistributionData?.formats || [],
                }]
                : [{
                    format: '',
                    text: '',
                    isKeepFrozenRequired: false,
                    formats: [],
                }],
        codingStatementsData: (() => {
            const raw = packagingData?.codingStatementsData ?? packagingData?.codingStatements;
            if (Array.isArray(raw) && raw.length > 0) {
                return raw.map((entry: any) => ({
                    id: entry?.id,
                    statement: entry?.statement || '',
                    useOnPack: entry?.useOnPack || '',
                }));
            }
            if (raw && typeof raw === 'object') {
                return [{
                    id: raw?.id,
                    statement: raw?.statement || '',
                    useOnPack: raw?.useOnPack || '',
                }];
            }
            return [{ statement: '', useOnPack: '' }];
        })(),
        additionalCertificatesData: {
            countryOfOriginStatement1: packagingData?.additionalCertificatesData?.countryOfOriginStatement1 || '',
            countryOfOriginCountry1: packagingData?.additionalCertificatesData?.countryOfOriginCountry1 || '',
            countryOfOriginStatement2: packagingData?.additionalCertificatesData?.countryOfOriginStatement2 || '',
            countryOfOriginCountry2: packagingData?.additionalCertificatesData?.countryOfOriginCountry2 || ''
        },
        printerInformationData: [{
            companyName: (packagingData?.printerInformationData?.companyName ?? packagingData?.printerInformationData?.printerCompanyName) || '',
            contactName: (packagingData?.printerInformationData?.contactName ?? packagingData?.printerInformationData?.printerContactName) || '',
            email: (packagingData?.printerInformationData?.email ?? packagingData?.printerInformationData?.printerEmail) || '',
            phone: (packagingData?.printerInformationData?.phone ?? packagingData?.printerInformationData?.printerPhone) || '',
            website: (packagingData?.printerInformationData?.website ?? packagingData?.printerInformationData?.printerWebsite) || '',
            country: (packagingData?.printerInformationData?.country ?? packagingData?.printerInformationData?.printerCountry) || '',
            addressLine1: (packagingData?.printerInformationData?.addressLine1 ?? packagingData?.printerInformationData?.printerAddressLine1) || '',
            addressLine2: (packagingData?.printerInformationData?.addressLine2 ?? packagingData?.printerInformationData?.printerAddressLine2) || ''

        }],
        printerDielineDetailsData: Array.isArray(packagingData?.printerDielineDetailsData) 
                ? (packagingData.printerDielineDetailsData.length > 0
                ? packagingData.printerDielineDetailsData
                : [{
                    printerCompanyName: '',
                    printerContactName: '',
                    printerEmailAddress: '',
                    printerPhone: '',
                    printerCountry: '',
                    printerAddressLine1: '',
                    printerAddressLine2: '',
                    printerCity: '',
                    printerStateRegionProvince: '',
                    printerZipPostalCode: '',
                    packagingComponent: '',
                    printSubstrate: '',
                    printProcess: '',
                    colors: ''
                }]
            )
            : packagingData?.printerDielineDetailsData 
                ? [packagingData.printerDielineDetailsData]
                : [{
                    printerCompanyName: '',
                    printerContactName: '',
                    printerEmailAddress: '',
                    printerPhone: '',
                    printerCountry: '',
                    printerAddressLine1: '',
                    printerAddressLine2: '',
                    printerCity: '',
                    printerStateRegionProvince: '',
                    printerZipPostalCode: '',
                    packagingComponent: '',
                    printSubstrate: '',
                    printProcess: '',
                    colors: ''
                }],
        artworkApproverDetailsData: packagingData?.artworkApproverDetailsData
            ? {
                artworkApproverName: packagingData.artworkApproverDetailsData.artworkApproverName ?? '',
                artworkApproverEmail: packagingData.artworkApproverDetailsData.artworkApproverEmail ?? '',
                artworkApproverPhone: packagingData.artworkApproverDetailsData.artworkApproverPhone ?? ''
              }
            : {
                artworkApproverName: '',
                artworkApproverEmail: '',
                artworkApproverPhone: ''
              },
        organicClaim: Array.isArray(packagingData?.organicClaim)
            ? (packagingData?.organicClaim?.length > 0
                ? packagingData.organicClaim
                : [{
                    icon: '',
                    useOnPack: '',
                    supportingTextForDeclaration: ''
                }])
            : packagingData?.organicClaim
                ? [packagingData.organicClaim]
                : [{
                    icon: '',
                    useOnPack: '',
                    supportingTextForDeclaration: ''
                }],
        organicCertifier: Array.isArray(packagingData?.organicCertifier)
            ? (packagingData?.organicCertifier?.length > 0
                ? packagingData.organicCertifier
                : [{
                    icon: '',
                    useOnPack: '',
                    supportingTextForDeclaration: ''
                }])
            : packagingData?.organicCertifier
                ? [packagingData.organicCertifier]
                : [{
                    icon: '',
                    useOnPack: '',
                    supportingTextForDeclaration: ''
                }],
        bottleRedemptionInformation: (Array.isArray(packagingData?.bottleRedemptionInformation) && packagingData?.bottleRedemptionInformation?.length > 0) 
            ? packagingData.bottleRedemptionInformation
            : packagingData?.bottleRedemptionInformation
                ? [packagingData.bottleRedemptionInformation]
                : [{
                    bottleRedemptionStates: [],  // Changed from empty string to empty array
                    useOnPack: '',
                    supportingTextForDeclaration: ''
                }],
        nonCopyInformationData: {
            designComments: packagingData?.nonCopyInformationData?.designComments || '',
            reasonForIssue: packagingData?.nonCopyInformationData?.reasonForIssue || '',
            designTeam: packagingData?.nonCopyInformationData?.designTeam || '',
            anyOtherInfoBackOfPack: packagingData?.nonCopyInformationData?.anyOtherInfoBackOfPack || '',
            photographyDateProductsReadyToShoot: packagingData?.nonCopyInformationData?.photographyDateProductsReadyToShoot || ''
        },
        cookingInstructionsData: {
            comments: packagingData?.cookingInstructionsData?.comments || ''
        },
        claimsDisclaimerStatementsData: Array.isArray(packagingData?.claimsDisclaimerStatementsData) && packagingData?.claimsDisclaimerStatementsData?.length > 0
            ? packagingData.claimsDisclaimerStatementsData
            : packagingData?.claimsDisclaimerStatementsData
                ? [packagingData.claimsDisclaimerStatementsData]
                : [{
                    statements: [],
                    useOnPack: '',
                    suitableForVegetarians: '',
                    suitableForVegans: ''
                }],
        countryOfOriginStatementsData: Array.isArray(packagingData?.countryOfOriginStatementsData) && packagingData?.countryOfOriginStatementsData?.length > 0 ? 
        packagingData?.countryOfOriginStatementsData :  [{
            countryOfOriginStatement1: null,
            countryOfOriginStatement2: null,
            countryOfOriginCountry1: '',
            countryOfOriginCountry2: '',
            reasonForCountryOfOrigin: '',
            cooRequiredOnLabel: '',
            supportingText: ''
        }],
        documentsData: {
            packagingDocuments: packagingData?.documentsData?.packagingDocuments || [],
            dielineDocuments: packagingData?.documentsData?.dielineDocuments || [],
            traceabilityLabelDocuments: packagingData?.documentsData?.traceabilityLabelDocuments || [],
            attachmentsSupportingText: packagingData?.documentsData?.attachmentsSupportingText || '',
            dielineDocumentsSupportingText: packagingData?.documentsData?.dielineDocumentsSupportingText || ''
        },
        kosherSymbolData: (Array.isArray(packagingData?.kosherSymbolData) && packagingData?.kosherSymbolData?.length)
            ? packagingData.kosherSymbolData 
            : packagingData?.kosherSymbolData 
                ? [packagingData.kosherSymbolData]
                : [{
                    onPackIcon: '',
                    supportingTextForDeclaration: '',
                    useOnPack: ''
                }],
        kosherDesignation: (Array.isArray(packagingData?.kosherDesignation) && packagingData?.kosherDesignation?.length)
            ? packagingData.kosherDesignation 
            : packagingData?.kosherDesignation 
                ? [packagingData.kosherDesignation]
                : [{
                    onPackIcon: '',
                    supportingTextForDeclaration: '',
                    useOnPack: ''
                }]
    };
}


export default OtherLabelingInitial;
